import {
  ADD_TO_CART,
  EDIT_CART_ITEM_QUANTITY,
  REMOVE_CART_ITEM,
  SET_WEBSHOP_ADDRESS,
  SET_WEBSHOP_FIRSTNAME,
  SET_WEBSHOP_LASTNAME,
  SET_WEBSHOP_MEMBERID,
  SET_WEBSHOP_SHIPPING,
  SET_IS_WALLET_FROZEN,
  RESET_CART
  , SET_WEBSHOP_PHONENUMBER
} from '@/utils/store/mutationTypes'

export default {
  [ADD_TO_CART] (state, { cartItem = {} }) {
    state.cart = [...state.cart, cartItem]
  },
  [EDIT_CART_ITEM_QUANTITY] (state, { productId, quantity }) {
    state.cart = state.cart.map(cartItem => ({
      ...cartItem,
      ...(cartItem.productId === productId ? { quantity } : {})
    }))
  },
  [REMOVE_CART_ITEM] (state, { productId }) {
    state.cart = state.cart.filter(cartItem => cartItem.productId !== productId)
  },
  [SET_WEBSHOP_ADDRESS] (state, { address = {} }) {
    state.address = address
  },
  [SET_WEBSHOP_LASTNAME] (state, { lastName = '' }) {
    state.lastName = lastName
  },
  [SET_WEBSHOP_FIRSTNAME] (state, { firstName = '' }) {
    state.firstName = firstName
  },
  [SET_WEBSHOP_PHONENUMBER] (state, { phoneNumber = '' }) {
    state.phoneNumber = phoneNumber
  },
  [SET_WEBSHOP_MEMBERID] (state, { memberId = null }) {
    state.memberId = memberId
  },
  [SET_WEBSHOP_SHIPPING] (state, { shipping = {} }) {
    state.shipping = shipping
  },
  [SET_IS_WALLET_FROZEN] (state, { isWalletFrozen = false }) {
    state.isWalletFrozen = isWalletFrozen
  },
  [RESET_CART] (state) {
    state.cart = []
  }
}
